import { useState } from 'react';
import styles from './index.less'


const PopularScienceArticles = (props: any) => {

  const {secondDepartName,contentOtherArt, icon_right, evaluate5} = props;
  const [idnexID, setIdnexID] = useState<any>(3);
  const deleteTag = (html: string) =>
  html
    .replace(/<.+?>/g, "")
    .replace(/<\/.+>/g, "")
    .replace(/\s+/g, " ")
    .replace(/<img.+\/>/gi, "")
    .replace(/\%/g, "")
    .trim();
    return (
            <div className={styles.articleList}>
              <div className={styles.articleListTit}>
                <div>{secondDepartName}科普文章</div>
              </div>
              <ul>
                {contentOtherArt?.map((itme: any, index: any) => {
                  if (index < idnexID) {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        window.open(
                          window.location.origin +
                            "/pccontent/" +
                            itme?.contentId
                        );
                      }}
                    >
                      <div className={styles.articleImg}>
                        {!itme.titlePicUrl && (
                          <img
                            src={
                              "https://image.healthjd.com/nethpim/" +
                              itme.titlePicUrl
                            }
                            alt=""
                            className={styles.articleImg1}
                          />
                        )}
                        <div className={styles.articleWidth}>
                          <div className={styles.articleListTop}>
                            <div
                              className={styles.articleListTopText}
                              data-tag-h2
                              data-a-href={
                                "/pccontent/" +
                                itme?.contentId
                              }
                            >
                              {itme?.contentName}
                            </div>
                            <div className={styles.articleListTopInfo}>
                              <span data-a-nofollow="true">点击查看</span>
                              <img src={icon_right} alt="" />
                            </div>
                          </div>
                          <div className={styles.consultationListBon}>
                            <div className={styles.consultationListBonLeft}>
                              <div
                                className={styles.consultationListBonLeftText1}
                              >
                                {itme?.contentParagraphs &&
                                  itme?.contentParagraphs.length > 0 &&
                                  itme?.contentParagraphs[0]
                                    ?.paragraphContent && (
                                    <h3
                                      dangerouslySetInnerHTML={{
                                        __html: deleteTag(
                                          itme?.contentParagraphs[0]
                                            .paragraphContent
                                        ),
                                      }}
                                    ></h3>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                }
                })}
              </ul>
              <ul className={styles.seourl}>
                {contentOtherArt?.map((itme: any, index: any) => {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        window.open(
                          window.location.origin +
                            "/pccontent/" +
                            itme?.contentId
                        );
                      }}
                    >
                      <div className={styles.articleImg}>
                        {!itme.titlePicUrl && (
                          <img
                            src={
                              "https://image.healthjd.com/nethpim/" +
                              itme.titlePicUrl
                            }
                            alt=""
                            className={styles.articleImg1}
                          />
                        )}
                        <div className={styles.articleWidth}>
                          <div className={styles.articleListTop}>
                          <div
                              className={styles.seoText}
                              data-tag-h2
                              data-a-href={
                                "/pccontent/" +
                                itme?.contentId
                              }
                            >
                              { itme?.contentParagraphs &&
                                  itme?.contentParagraphs.length > 0 &&
                                  ( itme?.contentName + "|" + deleteTag(itme?.contentParagraphs[0]
                                    ?.paragraphContent).substring(0, 100))
                              }
                            </div>
                            <a
                              className={styles.articleListTopText}
                              data-tag-h2
                              data-a-href={
                                "/pccontent/" +
                                itme?.contentId
                              }
                            >
                              {itme?.contentName}
                            </a>
                            <div className={styles.articleListTopInfo}>
                              <span data-a-nofollow="true">点击查看</span>
                              <img src={icon_right} alt="" />
                            </div>
                          </div>
                          <div className={styles.consultationListBon}>
                            <div className={styles.consultationListBonLeft}>
                              <div
                                className={styles.consultationListBonLeftText1}
                              >
                                {itme?.contentParagraphs &&
                                  itme?.contentParagraphs.length > 0 &&
                                  itme?.contentParagraphs[0]
                                    ?.paragraphContent && (
                                    <h3
                                      dangerouslySetInnerHTML={{
                                        __html: deleteTag(
                                          itme?.contentParagraphs[0]
                                            .paragraphContent
                                        ),
                                      }}
                                    ></h3>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
                {/* 展开更多 */}
              <div className={styles.pconsultationListMore}>
                <p
                  onClick={() => {
                    if (idnexID < 9) {
                      setIdnexID(10);
                    }
                  }}
                >
                  {contentOtherArt &&
                  contentOtherArt.length > 2 &&
                  idnexID < 9 ? (
                    <>
                      <span>展开更多</span>
                      <img src={evaluate5} alt="" />
                    </>
                  ) : null}
                </p>
              </div>
            </div>
    );
}

export default PopularScienceArticles;